'use client';

import { Kbd, PrefixHint } from './primitives';

export type MenuFooterText = {
  productsPrefix: string;
  threadsPrefix: string;
  commandsPrefix: string;
  navigate: string;
  select: string;
  backToAll: string;
};

export function MenuFooter({
  text,
  atRoot,
  onPrefix,
  onBack,
}: {
  text: MenuFooterText;
  atRoot: boolean;
  onPrefix: (prefix: string) => void;
  onBack: () => void;
}) {
  return (
    <div className="border-border/40 bg-muted/20 flex shrink-0 items-center justify-between gap-3 border-t px-3 py-2">
      <div className="flex min-w-0 items-center gap-3">
        {atRoot ? (
          <>
            <PrefixHint
              prefix="#"
              label={text.productsPrefix}
              onActivate={onPrefix}
            />
            <PrefixHint
              prefix="@"
              label={text.threadsPrefix}
              onActivate={onPrefix}
            />
            <PrefixHint
              prefix=">"
              label={text.commandsPrefix}
              onActivate={onPrefix}
            />
          </>
        ) : (
          <button
            type="button"
            tabIndex={-1}
            onMouseDown={(event) => {
              // Keep focus in the command input while popping the page.
              event.preventDefault();
              onBack();
            }}
            className="text-muted-foreground/60 hover:text-foreground inline-flex items-center gap-1.5 text-[11px] transition-colors"
          >
            <Kbd className="pointer-events-auto cursor-pointer">⌫</Kbd>
            <span>{text.backToAll}</span>
          </button>
        )}
      </div>
      <div className="text-muted-foreground/60 hidden shrink-0 items-center gap-3 text-[11px] sm:flex">
        <span className="inline-flex items-center gap-1">
          <Kbd>↑</Kbd>
          <Kbd>↓</Kbd>
          <span className="ml-0.5">{text.navigate}</span>
        </span>
        <span className="inline-flex items-center gap-1">
          <Kbd>↵</Kbd>
          <span className="ml-0.5">{text.select}</span>
        </span>
      </div>
    </div>
  );
}
